import { Link } from "react-router-dom";
import type { Topic } from "@/mocks/topics";

type Props = {
  topic: Topic;
  layout?: "vertical" | "horizontal";
};

export default function TopicCard({ topic, layout = "vertical" }: Props) {
  if (layout === "horizontal") {
    return (
      <Link
        to={`/topic/${topic.id}`}
        className="group flex gap-4 p-3 md:p-4 rounded-lg bg-background-50 border border-background-200/80 hover:border-primary-300 transition-colors cursor-pointer"
      >
        <div className="w-28 h-24 md:w-36 md:h-28 shrink-0 rounded-md overflow-hidden bg-background-200">
          <img
            src={topic.cover}
            alt={`${topic.title} - ${topic.categoryName}话题封面`}
            title={`${topic.title} ${topic.categoryName}`}
            className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
          />
        </div>
        <div className="min-w-0 flex-1">
          <span className="inline-block text-xs px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-900 mb-2">
            {topic.categoryName}
          </span>
          <h3 className="font-heading font-semibold text-foreground-950 text-sm md:text-base leading-snug line-clamp-2 group-hover:text-primary-700 transition-colors">
            {topic.title}
          </h3>
          <p className="hidden md:block text-xs text-foreground-500 mt-2 line-clamp-2">{topic.summary}</p>
          <div className="flex items-center gap-3 mt-2 text-xs text-foreground-500">
            <span className="flex items-center gap-1"><i className="ri-fire-line text-primary-500"></i>{topic.heat.toLocaleString()}</span>
            <span className="flex items-center gap-1"><i className="ri-chat-3-line"></i>{topic.commentCount}</span>
          </div>
        </div>
      </Link>
    );
  }

  return (
    <Link
      to={`/topic/${topic.id}`}
      className="group flex flex-col rounded-lg overflow-hidden bg-background-50 border border-background-200/80 hover:border-primary-300 transition-colors cursor-pointer"
    >
      <div className="w-full h-48 overflow-hidden bg-background-200">
        <img
          src={topic.cover}
          alt={`${topic.title} - ${topic.categoryName}话题封面`}
          title={`${topic.title} ${topic.categoryName}`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
      </div>
      <div className="flex flex-col flex-1 p-4 md:p-5">
        <div className="flex items-center gap-2 mb-3">
          <span className="text-xs px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-900">{topic.categoryName}</span>
          <span className="text-xs text-foreground-400">{topic.updatedAt}</span>
        </div>
        <h3 className="font-heading font-semibold text-foreground-950 text-base leading-snug line-clamp-2 group-hover:text-primary-700 transition-colors">
          {topic.title}
        </h3>
        <p className="text-sm text-foreground-600 mt-2.5 line-clamp-2 flex-1">{topic.summary}</p>
        <div className="flex items-center justify-between mt-4 pt-4 border-t border-background-200/70">
          <span className="text-xs text-foreground-500 flex items-center gap-1.5">
            <span className="w-6 h-6 flex items-center justify-center rounded-full bg-accent-100 text-accent-900 text-[11px]">
              {topic.author.slice(0, 1)}
            </span>
            {topic.author}
          </span>
          <span className="flex items-center gap-3 text-xs text-foreground-500">
            <span className="flex items-center gap-1"><i className="ri-fire-line text-primary-500"></i>{topic.heat.toLocaleString()}</span>
            <span className="flex items-center gap-1"><i className="ri-chat-3-line"></i>{topic.commentCount}</span>
          </span>
        </div>
      </div>
    </Link>
  );
}